export default {
  "videoAlert_notFound": "Media not found"
}